import React from 'react';
import { AD } from './admin.constants';
import { s } from './admin.styles';
import { ADIcon } from './ADIcon';
import { PromptRecord } from './admin.types';

interface PromptEditorProps {
  p: PromptRecord;
  onEdit: (id: string, value: string) => void;
}

export function PromptEditor({ p, onEdit }: PromptEditorProps) {
  const lineCount = p.body.split('\n').length;
  const variableCount = p.variables.length;
  const linkedToolCount = p.linkedTools.length;
  return (
    <>
      <div style={s.descBox}>
        <div style={s.descLab}>Description</div>
        <textarea defaultValue={p.description} style={s.descInput} aria-label="Description" />
      </div>

      <div style={s.editorCard}>
        <div style={s.editorTopRow}>
          <div style={s.editorTabs}>
            <span style={{ ...s.editorTab, ...s.editorTabActive }}>prompt.md</span>
            <span style={s.editorTab}>preview</span>
            <span style={s.editorTab}>diff</span>
          </div>
          <div style={s.editorMeta}>
            <span>{lineCount} lines</span>
            <span>·</span>
            <span>UTF-8</span>
            <span>·</span>
            <span style={{ color: '#34d399' }}>● saved</span>
          </div>
        </div>
        <textarea
          defaultValue={p.body}
          onChange={e => onEdit(p.id, e.target.value)}
          style={s.editorTextarea}
          aria-label="Prompt body"
        />
      </div>

      <div style={s.twoUp}>
        <div style={s.smallCard}>
          <div style={s.smallCardHead}>
            <ADIcon name="bolt" size={14} color={AD.PURPLE_STRONG} />
            <div style={s.smallCardTitle}>{'Variables · ' + variableCount}</div>
            <span style={s.smallCardLink}>+ Add</span>
          </div>
          <div style={s.varList}>
            {p.variables.map((v) => {
              const keyLabel = '{{' + v.key + '}}';
              return (
                <div key={v.key} style={s.varRow}>
                  <span style={s.varKey}>{keyLabel}</span>
                  <span style={s.varDesc}>{v.desc}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div style={s.smallCard}>
          <div style={s.smallCardHead}>
            <ADIcon name="link" size={14} color={AD.PURPLE_STRONG} />
            <div style={s.smallCardTitle}>{'Linked tools · ' + linkedToolCount}</div>
            <span style={s.smallCardLink}>+ Link</span>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {p.linkedTools.length > 0
              ? p.linkedTools.map((t) => <span key={t} style={s.chip}>{t}</span>)
              : <span style={{ fontSize: 12, color: AD.SLATE }}>No tools linked yet.</span>
            }
          </div>
        </div>
      </div>
    </>
  );
}
